import { Map, fromJS } from 'immutable';

export function request(state, { marketId, ruleId, data }) {
    return state.set(
        'update-rule4',
        (state.get('update-rule4') || Map())
            .set(marketId, Map({
                rule4: fromJS(data),
                state: 'IN_PROGRESS',
                ruleId
            }))
    );
}

export function error(state, { marketId, ruleId, errors }) {
    return state.set(
        'update-rule4',
        (state.get('update-rule4') || Map())
            .set(marketId, Map({
                rule4: state.getIn([ 'update-rule4', marketId, 'rule4' ]),
                state: 'ERROR',
                errors: fromJS(errors),
                ruleId
            }))
    );
}

export function finish(state, { marketId, ruleId, market }) {
    return state
        .set(
            'update-rule4',
            (state.get('update-rule4') || Map())
                .set(marketId, Map({
                    rule4: state.getIn([ 'update-rule4', marketId, 'rule4' ]),
                    state: 'FINISHED',
                    ruleId
                }))
        )
        .setIn([ 'items', market.id ], fromJS(market));
}
